import React from 'react';
import ResultStyles from './styles';

const ResultWrapper = (props) => <ResultStyles {...props} />;

export default ResultWrapper;
